// extracted by mini-css-extract-plugin
module.exports = {"list":"oIinTk","tag":"c_KVz5k","disabled":"IeaMiE","title":"c9YeyJ4"};